import {Component, Input, OnInit} from "@angular/core";
import {GeneralService} from "src/app/services/generalService";
import {DICTIONARY} from "../../../../dictionary";
import {NotificationService} from "../../../../services/notificationService";
import _ from "lodash";
import util from "util";

@Component({
	selector: 'collaboration-protection-new-rule-condition',
	templateUrl: './collaboration-protection-new-rule-condition.component.html',
})

export class CollaborationProtectionNewRuleConditionComponent implements OnInit {
	@Input('condition') conditionArr;
	@Input() conditionIndex;
	@Input() sensitivityTypesData;
	@Input() newRule;
	@Input() fileTypes;

	constructor(public gs:GeneralService,
				private ns:NotificationService) {
	}

	dic = DICTIONARY;
	rulesOptions = _.cloneDeep(this.dic.CONSTANTS.collaborationProtectionRule);
	isInvalidRuleData;
	format = util.format;
	_=_;
	invalidDrag;
	validDrag;
	conditionInEdit;
	mouseOverAttachment;
	valuesPopup;
	attachmentTypesPopup;
	sensitivity_types;
	modalData;

	filePermissionsTypes = ['anonymous', 'organization', 'users'];

	searchConditionText = '';
	searchResultNotFound = false;

	ngOnInit() {
		this.conditionArr.forEach(condition => {
			condition.subTypeShow = this.parseSubType(condition.subType);
		});

		this.sensitivity_types = this.sensitivityTypesData?.sensitivity_types || [];
	}

	changeConditionType = (condition, type) => {
		if (condition.type === type) {
			return;
		}

		condition.type = type;
		condition.isNewTypeSelected = true;
		condition.isNewSubTypeSelected = false;
		condition.is_negate = false;
		condition.subType = _.cloneDeep(this.dic.CONSTANTS.collaborationProtectionRule.types[condition.type].subTypes);
		condition.singleSubType = _.clone(this.dic.CONSTANTS.collaborationProtectionRule.types[condition.type].singleSubType);
		condition.placeholder = _.clone(this.dic.CONSTANTS.collaborationProtectionRule.types[condition.type].placeholder);
		condition.values = _.clone(this.dic.CONSTANTS.collaborationProtectionRule.types[condition.type].values);
		condition.data = {};
		condition.subTypeShow = this.parseSubType(condition.subType);
		if (condition.type === this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name ||
			condition.type === this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name) {
			condition.data.matchType = this.dic.CONSTANTS.ruleMatchType.exactMatch;
		}
		if (condition.type === this.dic.CONSTANTS.collaborationProtectionRule.types.sensitivity_type?.name) {
			condition.data.matchType = this.dic.CONSTANTS.ruleMatchType.contains;
		}
		if (condition.type === this.dic.CONSTANTS.collaborationProtectionRule.types.compliance?.name) {
			condition.data = _.cloneDeep(this.dic.CONSTANTS.collaborationProtectionRule.defaultCondition.data);
		}
		if (condition.type === this.dic.CONSTANTS.collaborationProtectionRule.types.file_permissions?.name) {
			condition.data.file_permissions = [];
		}
		const dataSrc = condition.isException ? this.newRule.exceptions : this.newRule.conditions;
		this.isConditionDataChanged(dataSrc);
	};

	isConditionDataChanged = (conditions) => {
		this.isInvalidRuleData = false;

		for (let i = 0; i < conditions.length; i++) {
			const conditionArr = conditions[i];

			conditionArr.forEach(condition => {
				switch (condition.type) {
					case this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name:
						if (!condition.data || !condition.data.keywords || (condition.data.keywords instanceof Array && !condition.data.keywords.length)) {
							condition.invalidKeywords = true;
							this.isInvalidRuleData = true;
							return;
						}
						else {
							condition.invalidKeywords = false;
						}
						break;

					case this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name:
						if ((!condition.data || !condition.data.emails || (condition.data.emails instanceof Array && !condition.data.emails.length)) &&
							(condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.exactMatch ||
								condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.startsWith ||
								condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.endsWith ||
								condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.contains)) {
							condition.invalidEmails = true;
							this.isInvalidRuleData = true;
							return;
						}
						else {
							condition.invalidEmails = false;
						}
						break;

					case this.dic.CONSTANTS.collaborationProtectionRule.types.attachment_types.name:
						if (!condition.data || (!condition.data.attachment_types && !condition.data.all_types) || (condition.data.attachment_types instanceof Array && !condition.data.attachment_types.length && !condition.data.all_types)) {
							condition.invalidAttachmentsTypes = true;
							this.isInvalidRuleData = true;
						}
						else {
							condition.invalidAttachmentsTypes = false;
						}
						break;

					case this.dic.CONSTANTS.collaborationProtectionRule.types.file_permissions.name:
						if (!condition.data || !condition.data.file_permissions || (condition.data.file_permissions instanceof Array && !condition.data.file_permissions.length)) {
							condition.invalidfilePermissionsTypes = true;
							this.isInvalidRuleData = true;
						}
						else {
							condition.invalidfilePermissionsTypes = false;
						}
						break;
				}
			});
		}
	};

	showAttachmentTypesPopup = (condition) => {
		const attachmentTypesList = _.map(this.fileTypes, (item, key) => ({
			..._.cloneDeep(item),
			type: key,
			selected: false
		}));
		let all_types;

		if (condition.data.attachment_types && (condition.data.attachment_types.length || condition.data.all_types)) {
			if (condition.data.all_types) {
				all_types = true;
				_.map(attachmentTypesList, item => item.selected = true);
			}
			else {
				all_types = false;
				attachmentTypesList.forEach(item => {
					item.selected = condition.data.attachment_types.includes(item.type);
				});
			}
		}
		else {
			all_types = false;
		}

		this.conditionInEdit = condition;

		this.attachmentTypesPopup = {
			all_types,
			fileTypesList: attachmentTypesList,
			show: true
		};
	}

	applyAttachmentTypesPopup = () => {
		const condition = this.conditionInEdit;

		const dataSrc = condition.isException ? this.newRule.exceptions : this.newRule.conditions;
		const enabledTypesArr = this.attachmentTypesPopup.fileTypesList
			.filter(item => item.selected)
			.map(item => item.type);

		condition.data["attachment_types"] = enabledTypesArr;
		condition.data["all_types"] = this.attachmentTypesPopup.all_types;
		condition.data["typesDisplay"] = enabledTypesArr.map(type => this.fileTypes[type]?.display).join(', ');

		this.isConditionDataChanged(dataSrc);

		this.attachmentTypesPopup = null;
	}

	searchAttachmentTypes = (searchTerm, activeFilters) => {
		this.attachmentTypesPopup.fileTypesList.forEach(fileType => {
			const isFound = searchFileExecute(fileType, searchTerm);
			if (!isFound) {
				fileType.hide = true;
				return;
			}

			fileType.hide = false;
		})
	};

	openSensitivityTypesPopup(condition) {
		if (!this.sensitivity_types?.length) {
			return;
		}

		_.map(this.sensitivity_types, t => {
			t.selected = false;
			if (!t.displayName) {
				t.displayName = `${t.name}${t.type === 'Custom' ? ' (Custom)' : ''}`;
			}
			return t;
		});

		if (!condition.data.sensitivity_types) {
			condition.data.sensitivity_types = [];
		}

		this.conditionInEdit = condition;
		this.modalData = {
			openSensitivityTypesPopup: true
		};
	};

	updateTypes(types, newTypes) {
		this.conditionInEdit.data.sensitivity_types = types;
		if (newTypes && newTypes.length) {
			this.sensitivity_types = this.sensitivity_types.concat(newTypes);
		}
		this.isInvalidRuleData = false;
	};

	cancelSensitivityTypesPopup() {
		this.modalData.openSensitivityTypesPopup = false;
	}

	updateComplianceShow(conditionData) {
		conditionData.complianceShow = [];
		_.each(Object.keys(conditionData.compliance), (key) => {
			if (conditionData.compliance[key] && conditionData.compliance[key].enabled) {
				conditionData.complianceShow.push(key);
			}
		});
		this.isInvalidRuleData = false;
	};

	toggleResourceType = (condition, resourceType) => {
		if (!condition.data.file_permissions) {
			condition.data.file_permissions = [];
		}
		const index = condition.data.file_permissions.indexOf(resourceType);
		if (index > -1) {
			condition.data.file_permissions.splice(index, 1);
		}
		else {
			condition.data.file_permissions.push(resourceType);
		}
		condition.invalidfilePermissionsTypes = false;
		this.isInvalidRuleData = false;
	};

	cancelNewRuleCondition(conditionOrIndex, conditionArrIndexInRule) {
		if (this.conditionArr.length === 1) {
			const dataSrc = this.conditionArr[0].isException ? this.newRule.exceptions : this.newRule.conditions;
			dataSrc.splice(conditionArrIndexInRule, 1);
		}
		else {
			this.conditionArr.splice(conditionOrIndex, 1);
		}

		if (this.newRule.conditions.length && (this.newRule.conditions.length !== 1 || (this.newRule.conditions.length === 1 && !this.newRule.conditions[0].result))) {
			this.isConditionDataChanged(this.newRule.conditions);
		}
	};

	showPopup = (condition) => {
		this.conditionInEdit = condition;
		this.valuesPopup = {name: '', placeholder: '', subtitle: '', currentList: [], loading: false, error: '', input: '', show: false, importFile: null, lateScroll: 30, loadMoreInProcessTS: null};
		switch (condition.type) {
			case this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name:
				this.valuesPopup.name = 'emails';
				this.valuesPopup.placeholder = 'email';
				if (condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.exactMatch) {
					this.valuesPopup.subtitle = 'This list accepts only valid and complete email addresses';
				}
				else if (condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.startsWith) {
					this.valuesPopup.subtitle = 'This list accepts any value that an email address can start with';
					this.valuesPopup.placeholder = 'email starts with';
				}
				else if (condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.endsWith) {
					this.valuesPopup.subtitle = 'This list accepts any value that an email address can ends with';
					this.valuesPopup.placeholder = 'email ends with';
				}
				else if (condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.contains) {
					this.valuesPopup.placeholder = 'email contains';
					this.valuesPopup.subtitle = 'This list accepts any string that can be found in an email address';
				}
				this.valuesPopup.currentList = _.cloneDeep(condition.data.emails) || [];
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name:
				this.valuesPopup.name = 'keywords';
				this.valuesPopup.placeholder = 'keyword';
				this.valuesPopup.subtitle = '';
				this.valuesPopup.currentList = _.cloneDeep(condition.data.keywords) || [];
				break;
		}

		this.valuesPopup.input = '';
		this.valuesPopup.show = true;
	}

	subtypeChanged = (condition) => {
		this.isInvalidRuleData = false;
		condition.invalidSubTypes = false;
		condition.subTypeShow = this.parseSubType(condition.subType);
	};

	parseSubType = (subType) => {
		let res = [];
		_.map(subType, (value, key) => {
			if (value) {
				res.push(key);
			}
		});
		return res;
	};

	changeMatchType = (matchType, condition) => {
		if (condition.data.matchType === matchType) {
			return;
		}
		condition.data.matchType = matchType;

		if (condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.moreThan) {
			condition.data.matchCount = condition.data.matchCount || 1;
		}

		this.isInvalidRuleData = false;
	};

	showMatchActions = (conditionObj) => {
		switch (conditionObj.type) {
			case this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name:
				conditionObj.actions = [
					this.dic.CONSTANTS.ruleMatchType.exactMatch,
					this.dic.CONSTANTS.ruleMatchType.startsWith,
					this.dic.CONSTANTS.ruleMatchType.endsWith,
					this.dic.CONSTANTS.ruleMatchType.internal,
					this.dic.CONSTANTS.ruleMatchType.external,
					this.dic.CONSTANTS.ruleMatchType.contains,
					this.dic.CONSTANTS.ruleMatchType.regex
				];
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name:
				conditionObj.actions = [
					this.dic.CONSTANTS.ruleMatchType.exactMatch,
					this.dic.CONSTANTS.ruleMatchType.contains,
					this.dic.CONSTANTS.ruleMatchType.regex
				];
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.sensitivity_type?.name:
				conditionObj.actions = [
					this.dic.CONSTANTS.ruleMatchType.contains,
					this.dic.CONSTANTS.ruleMatchType.exactMatch,
				];
				break;
		}
		conditionObj.showActions = !conditionObj.showActions;
	};

	applyPopupCondition = (condition) => {
		let dataKey;
		switch (condition.type) {
			case this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name:
				dataKey = 'emails';
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name:
				dataKey = 'keywords';
				break;
		}

		const dataSrc = condition.isException ? this.newRule.exceptions : this.newRule.conditions;

		condition.data[dataKey] = _.cloneDeep(this.valuesPopup.currentList);

		this.isConditionDataChanged(dataSrc);
		this.valuesPopup.show = false;
	}

	isValueChanged = (condition) => {
		this.ns.closeMessage();
		switch (condition.type) {
			case this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name:
				condition.invalidInput = !this.gs.validateEmail(this.valuesPopup.input) && condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.exactMatch;
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name:
				condition.invalidInput = false;
				break;
		}
	};

	handleKeypress(event: KeyboardEvent, condition: any) {
		if (event.keyCode === 13 && this.valuesPopup.input && !condition.invalidInput) {
			this.isValueAddedToList(condition);
		}
	}

	isValueAddedToList = (condition) => {
		if (!this.valuesPopup.input || condition.invalidInput) {
			return;
		}

		this.valuesPopup.input = this.valuesPopup.input.toLowerCase();
		if (_.includes(this.valuesPopup.currentList, this.valuesPopup.input)) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.XAlreadyExistInX, this.valuesPopup.input, 'list'));
			return;
		}

		this.valuesPopup.currentList.push(this.valuesPopup.input);
		this.valuesPopup.input = '';
	}

	isValueRemoved = (condition, value) => {
		this.valuesPopup.currentList = _.filter(this.valuesPopup.currentList, v => {
			return v !== value;
		});
	};

	importConditionListFromCsv = (file, condition) => {
		if (!file) {
			return;
		}
		this.valuesPopup.loading = true;
		let header, regex, optionalHeaders = null;
		const originalList = this.valuesPopup.currentList;
		const validationFuncAlwaysTrue = () => {
			return true;
		};
		let validationFunctions = [];
		switch (condition.type) {
			case this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name:
				header = 'keyword';
				validationFunctions.push(validationFuncAlwaysTrue);
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name:
				header = 'email';
				if (condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.exactMatch) {
					validationFunctions.push(this.gs.validateEmail);
				}
				else {
					validationFunctions.push(validationFuncAlwaysTrue);
				}
				break;
		}
		this.gs.readCsv(file, [header], optionalHeaders, regex, validationFunctions, (err, results) => {
			this.valuesPopup.file = null;

			if (err) {
				this.ns.showErrorMessage(err);
				this.valuesPopup.loading = false;
				return;
			}
			if (!results || !results[header] || !results[header].length) {
				this.ns.showErrorMessage(this.dic.ERRORS.noNewResult);
				this.valuesPopup.loading = false;
				return;
			}

			let newList = _.cloneDeep(originalList);

			for (let i = 0; i < results[header].length; i++) {
				if (!_.includes(newList, results[header][i])) {
					newList.push(results[header][i]);
				}
			}

			if (newList.length === originalList.length) {
				this.ns.showErrorMessage(this.dic.ERRORS.noNewResult);
				this.valuesPopup.loading = false;
				return;
			}

			this.valuesPopup.currentList = _.cloneDeep(newList);
			this.valuesPopup.loading = false;
		});
	};

	exportConditionListToCsv = (condition) => {
		let csvString = "";
		const list = this.valuesPopup.currentList;

		switch (condition.type) {
			case this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name:
				csvString = "Keyword";
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name:
				csvString = "Email";
				break;
		}

		if (!list.length) {
			return;
		}

		csvString += "\n";

		list.forEach((item) => {
			csvString += `${item}\n`;
		});

		this.gs.exportCsv(csvString, `Collaboration_Rule_Condition_${condition.type}.csv`);
	};

	searchCondition(searchTerm) {
		searchTerm = (searchTerm || '').toLowerCase();

		Object.values(this.rulesOptions.types).forEach(type => {
			type.hide = !type.label?.toLowerCase().includes(searchTerm);
		});

		this.searchResultNotFound = Object.values(this.rulesOptions.types).every((type: any) => type.hide);
	}

	clearSearchCondition() {
		this.searchConditionText = '';
		this.searchResultNotFound = false;
		Object.values(this.rulesOptions.types).forEach(type => {
			type.hide = false;
		});
	}

}

function searchFileExecute(record, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return (
		(record.display?.toLowerCase().includes(searchTerm)) ||
		(record.extension?.some(ext => ext.toLowerCase().includes(searchTerm)))
	);
}
